import React from 'react';
import { Clock } from 'lucide-react';
import { openingHours } from '../data/mock';

export const OpeningHoursSection = () => {
  const today = new Date().toLocaleDateString('de-AT', { weekday: 'long' });

  return (
    <section id="oeffnungszeiten" className="py-12 sm:py-16 lg:py-20 bg-[#f7f5f2]">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        {/* Section Header */}
        <div className="text-center mb-6 sm:mb-8">
          <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-[#1e1919] mb-2">
            Öffnungszeiten
          </h2>
          <p className="text-[#736c64] text-xs sm:text-sm">
            365 Tage im Jahr für Sie da
          </p>
        </div>

        {/* Hours Grid - Compact */}
        <div className="bg-white rounded-xl sm:rounded-2xl p-4 sm:p-6 shadow-sm">
          {/* Mobile: Single column, Desktop: Two columns */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-2 sm:gap-y-3">
            {openingHours.map((item, index) => {
              const isToday = item.day === today || (item.day.includes('Sonntag') && today === 'Sonntag');
              const isSunday = item.day.includes('Sonntag');

              return (
                <div
                  key={index}
                  className={`flex items-center justify-between py-2.5 sm:py-2 px-3 rounded-lg ${
                    isToday ? 'bg-[#fad24b]/20' : ''
                  }`}
                >
                  <span className={`text-xs sm:text-sm ${isToday ? 'font-semibold text-[#1e1919]' : 'text-[#736c64]'}`}>
                    {item.day}
                    {isToday && (
                      <span className="ml-2 text-[10px] sm:text-xs bg-[#fad24b] text-[#1e1919] px-1.5 py-0.5 rounded font-medium">
                        Heute
                      </span>
                    )}
                  </span>
                  <span className={`text-xs sm:text-sm font-medium ${
                    isSunday ? 'text-[#61525a]' : 'text-[#1e1919]'
                  }`}>
                    {item.hours}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default OpeningHoursSection;
